import request from '../../http/request'
export const getPFSendList = params => {
  return request.post(`${process.env.REACT_APP_API_URL}/nfc/v2/api/nfc/tag/list/NDDC`, params)
}

export const rePFSendNfcUid = params => {
  return request.post(`${process.env.REACT_APP_API_URL}/nfc-ant-service/tag/report/retryBinding`, params, {
    reSend: true
  })
}
export const getPFSendTotal = params => {
  return request.post(`${process.env.REACT_APP_API_URL}/nfc/v2/api/nfc/tag/summary/NDDC`, params)
}
export const getPFProductAndSize = params => {
  return request.get(`${process.env.REACT_APP_API_URL}/nfc/v2/api/pmd/skuAndSizeDictionaries`, {
    params
  })
}
export const getPFNspExport = params => {
  return request.post(`${process.env.REACT_APP_API_URL}/nfc/v2/api/nfc/tag/export/NDDC`, params, {
    responseType: 'blob',
    uploadOrDownload: true
  })
}
